import { forwardRef } from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import { useFontFamily } from 'utils/fontUtils';

const VuiMenuItem = forwardRef(({ children, ...rest }, ref) => {
  const { fontFamily } = useFontFamily();

  return (
    <MenuItem
      {...rest}
      ref={ref}
      sx={{
        fontFamily,
        ...rest.sx
      }}
    >
      {children}
    </MenuItem>
  );
});

// Setting default values for the props of VuiMenuItem
VuiMenuItem.defaultProps = {
  children: null,
};

// Typechecking props for the VuiMenuItem
VuiMenuItem.propTypes = {
  children: PropTypes.node,
};

export default VuiMenuItem; 